import React, {Component} from 'react';
import '../../css/mapstyle.css';
import AsyncSelect from 'react-select/lib/Async';
import {fetchApi} from '../../fetchApi';

const colourOptions = [
    {value: 'Detroit, MI', label: 'Ocean', color: '#00B8D9', hasvalue: true},
    {value: 'Michigan, MI', label: 'Blue', color: '#0052CC', disabled: true},
    {value: 'Farmington, MI', label: 'Purple', color: '#5243AA'},
    {value: 'Livonia, MI', label: 'Red', color: '#FF5630', isFixed: true},
    {value: 'Westland, MI', label: 'Orange', color: '#FF8B00'},
    {value: 'Wayne, MI', label: 'Yellow', color: '#FFC400'},
    {value: 'Romulus, MI', label: 'Green', color: '#36B37E'},
    {value: 'Windsor, MI', label: 'Forest', color: '#00875A'},
    {value: 'Dearborn,MI', label: 'Slate', color: '#253858'},
    {value: 'Ferndale,MI', label: 'Silver', color: '#666666'},
];

type State = {
    inputValue: string,
};

const filterColors = (inputValue: string) =>
    colourOptions.filter(i =>
        i.label.toLowerCase().includes(inputValue.toLowerCase())
    );

const loadOptions = (inputValue, callback) => {
    setTimeout(() => {
        callback(filterColors(inputValue));
    }, 1000);
};

export default class WithCallbacks extends Component<*, State> {
    state = {inputValue: ''};

    handleAreaChange = (item, action) => {
        if (action.action === 'select-option') {
            //console.log("item set", item)
            this.props.onAreaSelected(item);
        }
        if (action.action === 'clear') {
            this.props.flyMapToExtent(-98.585522, 39.8333333, 2.2)
        }

        this.setState({
            searchSelection: item,
            inputValue: ""
        });


    }

    handleInputChange = (newValue: string, {action}) => {
        if (
            action === "menu-close" ||
            action === "input-blur" ||
            action === "set-value"
        ) {
            return;
        } else {

            // const inputValue = newValue.replace(/\W/g, '');
            this.setState({inputValue: newValue});
            return newValue;
        }

    };

    areaLoadOptions = async (inputValue) => {
        //debugger
        console.log("areaLoadOptions is Called")
        // filter input value for invalid characters
        inputValue
        // inputValue = inputValue.replace(/[^A-Za-z0-9 .-,]/g, '');
        let filteredOptions = [];
        // define Create New Area button for bottom of select list
        let createNewOption = {"value": "0"};

        createNewOption.label =
            <div className="Select-menu"
                 onClick={(e, className, size) => this.showaddAreapopup(e, "divpopupadd", 'lg')}>
                <img src={this.state.adddrp} className="addplusicon"
                     onClick={(e, className, size) => this.showaddAreapopup(e, "divpopupadd", 'lg')}/>
                <label onClick={(e, className, size) => this.showaddAreapopup(e, "divpopupadd", 'lg')}> Create New
                    Area</label>
            </div>;


        if (inputValue.length < 3) {
            filteredOptions.push(createNewOption);
            return filteredOptions;
        }

        let formdata = {
            "query": `
                    query searchAreasQuery($input: String!) {
                    allSavedAreas(name_Icontains: $input, first:100) {
                        edges {
                        node {
                            id
                            name
                        }
                        }
                    }
                    }`, "variables": {"input": inputValue}
        };
        //console.log("form data",JSON.stringify(formdata))
        let response = await fetchApi("graphql", JSON.stringify(formdata))
        //console.log("response",response)
        let edges = response.data.allSavedAreas.edges;
        for (var i = 0; i < edges.length; i++) {
            let obj = {};
            obj.value = edges[i].node.id;
            obj.label = edges[i].node.name;
            filteredOptions.push(obj);
        }
        filteredOptions.push(createNewOption);
        //console.log("filteredOptions",filteredOptions)
        return filteredOptions;
    };


    geographyLoadOptions = async (inputValue) => {

        //console.log("geographyLoadOptions is Called")
        let filteredOptions = [];
        if (inputValue.length < 3) {
            return filteredOptions;
        }

        let formdata = {
            "query": `
            query searchGeographyQuery($input: SearchGeographyInput!) {
            searchGeography(search: $input, first:100) {
                edges {
                node {
                    id
                    geoId
                    geographicUnit
                    name
                    sumlevel
                }
                }
            }
            }`, "variables": {"input": {"searchText": inputValue}}
        };
        //console.log("form data",JSON.stringify(formdata))
        let response = await fetchApi("graphql", JSON.stringify(formdata))
        let edges = response.data.searchGeography.edges;
        for (var i = 0; i < edges.length; i++) {
            let obj = {};
            obj.value = edges[i].node.geoId;
            obj.label = edges[i].node.name;
            obj.geographicUnit = edges[i].node.geographicUnit;
            filteredOptions.push(obj);
        }
        return filteredOptions;
    };

    handleFocus = element => {
        if (this.state.searchSelection) {
            this.setState({inputValue: this.state.searchSelection.label})
        }
    };

    render() {
        const {inputValue, searchSelection} = this.state;
        const customStyles = {
            option: (provided, state) => ({
                ...provided,
                color: state.isSelected ? '#ffffff' : '#5a5a5a',
                cursor: 'pointer',
                textAlign: 'left',
            }),
            dropdownIndicator: (provided, state) => ({
                display: 'none'
            }),
           /* indicatorsContainer: (provided, state) => ({
                display: 'none'
            }),*/
            control: (provided, state) => ({
                display: "flex",
                cursor: 'pointer',
            }),
            input: (provided, state) => ({
                ...provided,
                color: "#5A5A5A",
            }),
            menuList: (provided, state) => ({
                ...provided,
                maxHeight: "150px",
            }),
            menu: (provided, state) => ({
                ...provided,
                left: "14px",
            }),
            singleValue: (provided, state) => ({
                ...provided,
                color: "#5A5A5A",
            }),
        };
        return (
            <div>

                <AsyncSelect
                    className="menu-right-border"
                    placeholder=" Search Locations"
                    autosize={true}
                    cacheOptions={this.props.isSearchingUsAreas === true}
                    loadOptions={this.props.isSearchingUsAreas === true ?
                        this.geographyLoadOptions :
                        this.areaLoadOptions}
                    defaultOptions
                    onChange={this.handleAreaChange}
                    onInputChange={this.handleInputChange}
                    styles={customStyles}
                    inputValue={inputValue}
                    value={searchSelection}
                    onSelectResetsInput={false}
                    blurInputOnSelect={true}
                    isClearable
                    noOptionsMessage={()=> "Type the name of a county, city, etc."}
                    onFocus={this.handleFocus}
                />

            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ReactSelectAsync/ReactSelectAsync.js